/**
 * @fileoverview File type detection utilities for DmsFileViewer
 */

/**
 * Supported file types and their extensions
 */
export const FILE_TYPE_CONFIG = {
    pdf: ["pdf"],
    image: ["jpg", "jpeg", "png", "gif", "webp", "svg"],
    video: ["mp4", "webm", "mov", "avi"]
};

/**
 * Extract file extension from filename
 * @param {string} filename - The filename
 * @returns {string} The lowercase extension without dot
 */
export const getFileExtension = (filename) => {
    if (!filename) return "";
    return filename.split(".").pop().toLowerCase();
};

/**
 * Determine file type from filename
 * @param {string} filename - The filename
 * @returns {string} The file type: "pdf", "image", "video", or "unknown"
 */
export const getFileType = (filename) => {
    const ext = getFileExtension(filename);
    for (const [type, extensions] of Object.entries(FILE_TYPE_CONFIG)) {
        if (extensions.includes(ext)) return type;
    }
    return "unknown";
};
